<template>
  <div class="KYCAppBanner">
    <div
      class="KYCAppBanner__background"
      data-aos="fade-left"
      data-aos-offset="300"
      data-aos-easing="ease-in-sine"
    ></div>
    <div
      class="KYCAppBanner__qr-container"
      data-aos="fade-right"
      data-aos-offset="300"
      data-aos-easing="ease-in-sine"
    >
      <div class="KYCAppBanner__box">
        <div class="KYCAppBanner-title" v-html="nl2br(title)"></div>
        <div class="KYCAppBanner-description" v-html="nl2br(description)"></div>
        <div class="KYCAppBanner-qr-box">
          <div
            class="KYCAppBanner-qr-code"
            v-for="(app, index) in appBanner"
            :key="index"
          >
            <div
              class="KYCAppBanner-qr-title"
              :style="`background: ${
                app.type === 'iOS' ? '#4b6ec3' : '#41a0be'
              }`"
            >
              {{ app.title }}
              <div
                class="arrow"
                :style="`background: ${
                  app.type === 'iOS' ? '#4b6ec3' : '#41a0be'
                }`"
              ></div>
            </div>
            <div>
              <img
                width="110px"
                :src="
                  require(`../../assets/img/kyc_info/img_${app.type}_qr.png?v=1.1`)
                "
              />
            </div>
            <div class="KYCAppBanner-qr-description">{{ app.description }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AOS from "aos";
import "aos/dist/aos.css";
AOS.init();

export default {
  name: "KYCAppBanner",
  data() {
    return {
      title: "아직 플라이빗 앱을\n다운받지 않으셨나요?",
      description: "아래 보이는 QR코드를 통해 플라이빗 앱을 설치해 보세요.",
      appBanner: [
        {
          title: "안드로이드 사용자",
          description: "Android 다운로드",
          type: "Android",
        },
        {
          title: "아이폰 사용자",
          description: "플라이빗 모바일 웹 QR",
          type: "iOS",
        },
      ],
    };
  },
  methods: {
    nl2br(str) {
      return str.replace(/\n/g, "<br />");
    },
  },
};
</script>
<style lang="scss" scoped>
.KYCAppBanner {
  background: #f8f9fa;

  &__qr-container {
    padding: 40px 38px;
    text-align: center;
  }

  &__box {
    width: 100%;
    margin: 0 auto;
  }

  &__background {
    width: 100%;
    height: 187px;
    background: url("~@/assets/img/kyc_info/img_app_banner_back.jpg?v=1.1")
      no-repeat left top / cover;
  }

  &-title {
    color: #222222;
    font-size: 24px;
    font-weight: 500;
    line-height: 1.3;
    text-align: center;
  }

  &-description {
    color: #222222;
    font-size: 14px;
    font-weight: 300;
    margin-top: 10px;
    text-align: center;
  }

  &-qr-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 40px;
  }

  &-qr-code {
    text-align: center;
  }

  &-qr-title {
    width: 110px;
    height: 31px;
    font-size: 12px;
    color: #fafbfc;
    border-radius: 4px;
    font-weight: 300;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    position: relative;

    .arrow {
      width: 8px;
      height: 8px;
      position: absolute;
      bottom: -4px;
      left: 50%;
      transform: translate(-50%, 0) rotate(45deg);
    }
  }

  &-qr-description {
    font-size: 14px;
    color: #222;
    margin-top: 14px;
    font-weight: 500;
  }
}
</style>
